export default {
  workProcessContent: {
    subtitle: "كيف يعمل",

    title1: "عملية شراء بسيطة",
    title2: "وشفافة",

    step1_title: "تصفح واختر",
    step1_desc:
      "اختر المنتجات من موردين موثوقين بأسعار شفافة.",

    step2_title: "أضف إلى السلة",
    step2_desc:
      "إدارة الكميات والجداول والطلبات المتكررة بسهولة.",

    step3_title: "دفع آمن",
    step3_desc:
      "ادفع بأمان مع فواتير واضحة وخيارات مناسبة للأعمال.",

    step4_title: "توصيل موثوق",
    step4_desc:
      "استلم منتجاتك الطازجة في الوقت المحدد عبر شبكة التوصيل لدينا.",
  },
};